import useSWR, { SWRConfiguration } from 'swr'
import { learningApi } from '../../../services/api'
import { TSummaryQuestion } from '../components/QuestionsSummary/types'
import { useEffect, useState } from 'react'
import { useDebouncedState } from '../../../hooks/use-debounced-state'

const ITEMS_PER_PAGE = 10

const useGetSummary = (questionBookId: string) => {
  const token = localStorage.getItem('token')
  const [page, setPage] = useState(1)
  const [status, setStatus] = useState('')
  const [search, setSearch] = useState('')

  const [debouncedSearch, setDebouncedSearch] = useDebouncedState('', 500)

  const params = new URLSearchParams(`?page=1&limit=${page * ITEMS_PER_PAGE}`)

  if (debouncedSearch) params.append('search', debouncedSearch)
  if (status) params.append('status', status)

  const swr = useSWR<{ docs: TSummaryQuestion[]; total: number }>(
    `/question/books/${questionBookId}/summary?${params.toString()}`,
    fetcher(token),
    configuration
  )

  const reachedEnd = swr.data.total <= page * ITEMS_PER_PAGE
  const isEmpty = swr.isLoading === false && (swr.data.total === undefined || swr.data.total === 0)

  const setSearchProxy = (value: string) => {
    setSearch(value)
    setDebouncedSearch(value)
  }

  useEffect(() => {
    setPage(1)
  }, [debouncedSearch, status])

  return { swr, setPage, search, setSearch: setSearchProxy, status, setStatus, reachedEnd, isEmpty }
}

const fetcher = (token: string) => (url: string) =>
  learningApi
    .get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)

const configuration: SWRConfiguration = {
  fallbackData: { docs: [], total: 0 },
  keepPreviousData: true,
}

export default useGetSummary
